//------------------------------------------------------------------------
//  bmtAdhocLimits
//
//  Normalize, dedup, and cap a textarea's multi-line value list for the
//  BMT string-type adhoc filter. Returns counts for UI feedback.
//
//  Dedup is exact-match, case-sensitive, first-seen-wins. Each line is
//  trimmed (leading + trailing whitespace) and empty lines are dropped
//  before dedup.
//------------------------------------------------------------------------

export const ADHOC_STRING_MAX_VALUES = 200;

export function dedupAndCapValues(raw, max = ADHOC_STRING_MAX_VALUES) {
  if (typeof raw !== 'string' || raw.length === 0) {
    return { text: '', totalCount: 0, uniqueCount: 0, kept: 0, dropped: 0 };
  }

  const lines = raw.split('\n');
  const nonEmpty = [];
  for (let i = 0; i < lines.length; i++) {
    const t = lines[i].trim();
    if (t.length > 0) nonEmpty.push(t);
  }
  const totalCount = nonEmpty.length;

  const seen = new Set();
  const unique = [];
  for (let i = 0; i < nonEmpty.length; i++) {
    const v = nonEmpty[i];
    if (!seen.has(v)) {
      seen.add(v);
      unique.push(v);
    }
  }
  const uniqueCount = unique.length;

  const kept = Math.min(uniqueCount, max);
  const keptValues = unique.slice(0, kept);

  return {
    text: keptValues.join('\n'),
    totalCount,
    uniqueCount,
    kept,
    dropped: totalCount - kept,
  };
}
